module.exports = __webpack_public_path__ + "img/home4.19a8e4aa.jpg";